import { styled } from 'styled-components';
import { Course } from './Course';
import type { Course as CourseType, Series } from './types';

type SeriesSectionProps = {
  series: Series;
};

export function SeriesSection({ series }: SeriesSectionProps) {
  return (
    <SeriesContainer>
      <SeriesTitle>{series.title}</SeriesTitle>
      <FullWidthDivider />
      <CoursesGrid>
        {series.courses.map((course: CourseType) => (
          <Course key={course.id} course={course} />
        ))}
      </CoursesGrid>
    </SeriesContainer>
  );
}

const spacingVariable = 24;

const CoursesGrid = styled.div`
  display: grid;
  gap: 16px;
  padding-top: 28px;
`;

const FullWidthDivider = styled.div`
  box-shadow: var(--shadow-color) 0.5px 0.5px 1px 0px;
  height: 1px;
  margin-left: -${spacingVariable}px;
  margin-right: -${spacingVariable}px;
  width: calc(100% + ${spacingVariable * 2}px);
`;

const SeriesContainer = styled.div`
  border-radius: 5px;
  box-shadow: var(--shadow-color) 0.5px 1px 3px 0px;
  display: flex;
  flex-direction: column;
  padding: 2px ${spacingVariable}px 26px ${spacingVariable}px;
`;

const SeriesTitle = styled.div`
  color: var(--grey-1000);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  margin-left: -8px;
  padding: 10px 0;
  width: 100%;
`;
